<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
        'store': Object,
    },
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();

            if (vm.store.id)
                vm.data.store_id = vm.store.id;
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                store_id: null,
                ref_no: null,
                name: null,
                address: null,
            };

            vm.data = Object.assign({}, data);
        },
        fetchStore: async function (params) {
            const resp = await this.$api.Store.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        async submit() {
            var vm = this;
            vm.$loading.on('store_detail_branch_store_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Branch.create(postData);

                var data = resp.data;

                vm.$flash.success(data.message);

                vm.success(vm.data);
                vm.$sidebar.hide();
            } catch (err) {
                vm.$flash.error(err.response.data.message);
            }
            vm.$loading.off('store_detail_branch_store_submit');
        },
        _createPostData: function (data) {
            return data;
        }
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12" v-if="$ac.hasAccess('branch_full_access')">
                        <label class="form-label" for="product-title-input">{{ $t('branch.label.ref_no') }}</label>
                        <input type="text" class="form-control" v-model="data.ref_no" id="product-title-input"
                            :placeholder="$t('branch.placeholder.ref_no')" />
                    </BCol>
                    <BCol lg="12" v-if="$ac.hasAccess('branch_full_access')">
                        <label for="choices-publish-status-input" class="form-label">{{ $t('branch.label.store')
                            }}</label>
                        <dynamic-select v-model="data.store_id" :placeholder="$t('branch.placeholder.store')"
                            :loadOptions="fetchStore" />
                    </BCol>
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('branch.label.name') }}</label>
                        <input type="text" class="form-control" v-model="data.name" id="product-title-input"
                            :placeholder="$t('branch.placeholder.name')" />
                    </BCol>
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('branch.label.address') }}</label>
                        <textarea class="form-control" id="exampleFormControlTextarea5" rows="3" v-model="data.address"
                            :placeholder="$t('branch.placeholder.address')"></textarea>
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="($ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_create') && $ac.hasAccessStore(data.store_id)))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="success" class="w-100" @click="submit"
                                    :disabled="$loading.get('store_detail_branch_store_submit')">
                                    <loading :loading="$loading.get('store_detail_branch_store_submit')">
                                        <i class="mdi mdi-floppy me-1"></i>
                                        {{ $t('basic.btn.save') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>